import { Component } from "@angular/core";
import { SelectWindow, ModalService } from "@xo/client-common";
import { Type1Base, Type1BaseType } from "./Type1Base";

@Component({
    selector: "spec-app-type1-base-select",
    templateUrl: "./type1Base.select.html",
    styleUrls: ["./type1Base.select.scss"]
})
export class Type1BaseSelect extends SelectWindow<Type1Base> {

    constructor(modalService: ModalService) {
        super(modalService, Type1BaseType, "name");
    }
}
